import { FC } from "react";

import { StackItemsProps } from "./types";

import styles from "./StackItems.module.css";



const StackItems: FC<StackItemsProps> = ({
  items,
  count,
}) => {
  return (
    <div className={styles.stack}>
      {items.map((item, index) => (
        <div key={index} className={styles.stack__item}>
          <img src={item.url} alt={item.name} />
        </div>
      ))}
      <p className={styles.stack__count}>+{count}</p>
    </div>
  );
}

export default StackItems;
